import { computed, inject, Injectable } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { FooterToolbarSaveButtonService } from './footer-toolbar-save-button/footer-toolbar-save-button.service';

@Injectable({
    providedIn: 'root',
})
export class FooterToolbarService {

    footerToolbarSaveButtonService = inject(FooterToolbarSaveButtonService);

    saveButtonVisible = this.footerToolbarSaveButtonService.visibleTrigger;

    private _visible = computed(() => {
        return this.saveButtonVisible() != undefined; // || other component != undefined || other component != undefined
    })
    visible$ = toObservable<boolean>(this._visible);

}
